import Vue from "vue";
import Vuex from "vuex";
import Authentication from "./modules/authentication";
import Reports from "./modules/reports";
import { getModule } from "vuex-module-decorators";
import localforage from "localforage";

Vue.use(Vuex);

export const DB_NAME: string = "visitreports";
export const DB_STORE_NAME: string = "app_data";
export const TEMPFILES_UPLOAD_ENDPOINT: string = "https://ci04.ci.xist4c.de/gateway/upload/tempfiles";
export const CREATE_AUTH_TOKEN_ENDPOINT: string = "https://ci04.ci.xist4c.de/gateway/login";
export const LOGIN_CHECK_ENDPOINT: string = "https://ci04.ci.xist4c.de/gateway/tasks/logged_in";
export const AUTH_TOKEN: string = "015b3510b8f39bf9f49ef82767070e1e37de3cf6";
export const APP_ID: string = "5d35b7cd4c366a18c42ba577";

localforage.config({
  name: DB_NAME,
  storeName: DB_STORE_NAME
});

const store = new Vuex.Store({
  modules: {
    authentication: Authentication,
    storeReports: Reports
  },
  strict: process.env.NODE_ENV !== "production"
});

export default store;
// export const StoreMain = getModule(Main, store);
export const StoreAuthentication = getModule(Authentication, store);
export const StoreReports = getModule(Reports, store);
